import React from 'react';
import { SalesPopup } from './components/SalesPopup';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { ProductDetails } from './components/ProductDetails';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalOffer } from './components/FinalOffer';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-brand-yellow selection:text-black" data-id="element-0">
      <SalesPopup data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <ProductDetails data-id="element-5" />
        <Bonuses data-id="element-6" />
        <Testimonials data-id="element-7" />
        <FAQ data-id="element-8" />
        <FinalOffer data-id="element-9" />
      </main>

      <footer className="bg-black text-gray-400 py-8 text-center text-sm px-4" data-id="element-10">
        <div className="max-w-4xl mx-auto" data-id="element-11">
          <p className="mb-4" data-id="element-12">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
          <p data-id="element-13">
            Descargo de responsabilidad: La información contenida en esta guía
            es solo para fines educativos e informativos y no debe interpretarse
            como consejo médico.
          </p>
          <p className="mt-4" data-id="element-14">
            © {new Date().getFullYear()} Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}